import { render, staticRenderFns } from "./OrganismGuidedTourLauncher.vue?vue&type=template&id=8a44750a&"
import script from "./OrganismGuidedTourLauncher.vue?vue&type=script&lang=js&"
export * from "./OrganismGuidedTourLauncher.vue?vue&type=script&lang=js&"
import style0 from "./OrganismGuidedTourLauncher.vue?vue&type=style&index=0&id=8a44750a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismGuidedTourLauncher.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Fproject%2Fbuilding%2FOrganismGuidedTourLauncher.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomCircleProgress: require('/app/components/atoms/common/AtomCircleProgress.vue').default})
